import Map from './lib/map';

Array.from(document.body.querySelectorAll('div.map')).forEach((mapContainer) => new Map(mapContainer as HTMLElement));
